import { StandardEvents } from '@shopify/events';

/**
 * Product-page blocks that depend on the selected variant (set switcher, colour note). When the variant changes,
 * Horizon fetches the page HTML for the new variant (variant-picker.js) and passes it on the productSelect event;
 * we take this block's fresh markup from that HTML, so the Liquid stays the only place the content is built.
 * Each element needs a data-block-id that is unique on the page.
 */
class HfLiveBlock extends HTMLElement {
  #section = null;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section = null;
  }

  /** @param {Event & { promise?: Promise<{ detail?: { html?: Document } }> }} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        const tag = this.localName;
        const fresh = detail?.html?.querySelector(`${tag}[data-block-id="${this.dataset.blockId}"]`);
        if (fresh) this.replaceChildren(...fresh.childNodes);
      })
      .catch(() => {});
  };
}

for (const tag of ['hf-set-switcher', 'hf-colour-note']) {
  if (!customElements.get(tag)) customElements.define(tag, class extends HfLiveBlock {});
}
